import { useMutation, useQueryClient } from '@tanstack/react-query'
import { postUser } from '../../../../data/admin'
import { User } from '../../../../model/User'
import { addValid } from '../../../../store/message'
import { useActionDispatch } from '../../../utils'
import { useLocation, useNavigate } from 'react-router-dom'
import { userKeys } from './users.keys'
import { UserFriendlyError } from '../../../../model/Error'
import { handleApiError } from '../../../../misc/api.utilities'

export const usePostUser = (redirectAfterCreation?: boolean) => {
  const valid = useActionDispatch(addValid)
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()

  const queryReturn = useMutation({
    mutationFn: async (variables: Partial<User>) => {
      const apiResponse = await postUser(variables)
      const { data, ok } = apiResponse

      if (!data || !ok) {
        handleApiError(apiResponse)
        throw new UserFriendlyError('error', "La création d'utilisateur a échoué")
      }
      return data
    },

    onSuccess: (data) => {
      valid('Utilisateur créé avec succès')
      const { returnTo, interopFormState } = (location.state ?? {}) as {
        returnTo?: string
        interopFormState?: unknown
      }
      if (returnTo) {
        navigate(returnTo, { state: { interopFormState } })
      } else if (redirectAfterCreation) {
        navigate(`/admin/users/${data.id}`)
      }
      queryClient.removeQueries({ queryKey: userKeys.all })
      queryClient.setQueryData(userKeys.detail(data.id), data)
    },
  })

  return queryReturn
}
